import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { GlobalStorage } from '../../core/services/globals.service';

import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { Util } from 'src/app/shared/common/utils/util';
import {
  formattedTodayddmmyyyySlashs,
  stringToRutFormatted,
} from '../../core/utils/formatters';
import {
  getSpanishNextMonthAsTextPlusYear,
  toTitleCase,
} from '../../core/utils/functions';

@Component({
    selector: 'app-successful-stop-subscription',
    templateUrl: './successful-stop-subscription.component.html',
    styleUrls: ['./successful-stop-subscription.component.scss'],
    standalone: false
})
export class SuccessfulStopSubscriptionComponent implements OnInit,AfterViewInit{
  voucherInfo = {
    documentNumber: '',
    requestDate: '',
    stopDate: '',
    employerBusiness: '',
    employerRut: '',
    employerMail: '',
    userFullName: '',
    userRut: '',
    userMail: '',
  };
  public isMobile = false;

  constructor(
    private readonly globalSvc: GlobalStorage,
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly util: Util
  ) {
    this.isMobile = (this.document.defaultView as any).Capacitor;
  }

  ngAfterViewInit() {
    const botDiv = document.getElementById('botDiv');
    const content = document.querySelector('.success-container');
  
    if (botDiv && content) {
      content.classList.add('with-bot');
    }
  }
  ngOnInit(): void {
    this.formatVoucherData();
  }

  private formatVoucherData(): void {
    this.voucherInfo.documentNumber =
      this.globalSvc.stopSubscriptionDocumentNumber;
    this.voucherInfo.userMail = this.globalSvc.userData.email;
    this.voucherInfo.userFullName = toTitleCase(this.globalSvc.userData.name);
    this.voucherInfo.userRut = stringToRutFormatted(
      this.globalSvc.userData.rut
    );
    this.voucherInfo.requestDate = formattedTodayddmmyyyySlashs();

    this.voucherInfo.stopDate = getSpanishNextMonthAsTextPlusYear();
    this.voucherInfo.employerBusiness =
      this.globalSvc.stopSubscriptionEmployerData.business;

    const removeLeadingZerosRut =
      this.globalSvc.stopSubscriptionEmployerData.rut.replace(/^0+/, '');

    this.voucherInfo.employerRut = stringToRutFormatted(removeLeadingZerosRut);
    this.voucherInfo.employerMail =
      this.globalSvc.stopSubscriptionEmployerData.email;

    this.util.levantarEncuesta('Revocar-APV');
  }

  downloadMyFile(): void {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      `data:application/pdf;base64,${this.globalSvc.stopSubscriptionEmployerData.pdf.content}`
    );
    link.setAttribute('download', `Comprobante_revocacion_APV.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  salir() {
    void this.router.navigate(['/home/CCO']);
  }
}
